import { OutlinedInput, InputAdornment, Box, IconButton, styled, Typography, Divider } from '@mui/material';
import { PrintTwoTone, FilterList, AddSharp } from '@mui/icons-material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconSearch } from '@tabler/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import ReactToPrint from 'react-to-print';
import GlobalDrawer from './GlobalDrawer';
import GlobalFilter from './GlobalFilter';
import barcode from '../../assets/images/icons/barcode.svg';
import excel from '../../assets/images/icons/excel.icon.svg';
import report from '../../assets/images/icons/Report.svg';
import { Filter, RequestParams } from 'types/pagination';
import { useTheme } from '@mui/styles';

import { SyncIcon } from 'utils/Icons';
import { useEffect, useRef, useState } from 'react';
import { ExportToExcel } from 'types/question';
import { getAttendanceReport } from 'services/CourseService';
import { openSnackbar } from 'store/slices/snackbar';
import { useDispatch } from 'react-redux';

export interface editProps {
    setAdd?: (value: boolean) => void;
    setSync?: (value: boolean) => void;
    setCrmDetails?: (value: boolean) => void;
    label?: string;
    printRef: React.RefObject<HTMLElement>;
    setFilter?: (value: boolean) => void;
    filter?: boolean;
    setSearchText?: (value: string) => void;
    disabled?: boolean;
    setFilters?: (val: Filter[]) => void;
    filters?: Filter[];
    availableFilters?: any;
    columnCount?: number;
    path?: ExportToExcel;
    isQuestionFlag?: number;
    syncDisable?: boolean;
    setSyncDisable?: (val: boolean) => void;
}

const SubSearchSection = (props: editProps) => {
    const {
        availableFilters,
        filters,
        setFilters,
        disabled,
        path,
        setAdd = undefined,
        setSync = undefined,
        setCrmDetails = undefined,
        setFilter = undefined,
        label,
        printRef,
        filter = undefined,
        isQuestionFlag,
        setSearchText = undefined,
        columnCount = 0,
        syncDisable,
        setSyncDisable
    } = props;
    const [falg, setFlag] = useState<boolean>(false);
    const theme = useTheme();
    const [requestParams, setRequestParams] = useState<RequestParams>({
        page: 0,
        per_page: 0,
        sort: [{ field: 'difficulty_level', sort: 'desc' }],
        filters: []
    });
    const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const searchResults = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (setSearchText !== undefined) {
            const searchTerm = event.currentTarget.value;
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

            // Set a new timeout to delay search execution
            searchTimeoutRef.current = setTimeout(() => setSearchText?.(searchTerm), 500);
        }
    };
    useEffect(
        () => () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        },
        []
    );

    // const [path, setpath] = useState<ExportToExcel>();
    const excelUrl = process.env.REACT_APP_IMAGE_PATH || '';
    // useEffect(() => {
    //     if (isQuestionFlag == 1) {
    //         getQuestionsExcel(setpath, requestParams);
    //     }
    // }, [isQuestionFlag == 1]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (falg) {
            setSyncDisable && setSyncDisable(true);
        }
    }, [falg]);

    const H3 = styled(Typography)({
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '40px',
        letterSpacing: '0em',
        textAlign: 'left',
        paddingLeft: '16px'
    });

    const WrapperIcon = styled(IconButton)({
        background: 'rgba(0, 0, 0, 0.18)',
        height: '32px',
        width: '32px',
        borderRadius: '12px'
    });

    const AddIconButton = styled(IconButton)(() => ({
        height: 'fit-content',
        marginRight: '14px',
        padding: '8px',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            background: theme.palette.primary.dark
        }
    }));
    const pageStyle = `
        @media print {
            .MuiDataGrid-columnHeader, .MuiDataGrid-columnHeader--sortable, .MuiDataGrid-columnHeader--sorted,
            .MuiDataGrid-cell, .MuiDataGrid-cell--textLeft {
                width: ${columnCount > 0 ? 100 / columnCount : 15}% !important;
                max-width: ${columnCount > 0 ? 100 / columnCount : 15}% !important;
                min-width: ${columnCount > 0 ? 100 / columnCount : 15}% !important;
                font-size: ${columnCount > 4 ? 11 : 12}px;
            }
            .MuiDataGrid-columnHeaderWrapper, .MuiDataGrid-dataContainer, .MuiDataGrid-viewport, .MuiDataGrid-renderingZone, .MuiDataGrid-row {
                min-width: 100% !important;
                width: 100% !important;
                margin-left: 0px;
            }
            div[data-field="action"] *,  div[data-field="action"],
            div[data-field="forms"] *, div[data-field="forms"] {
                display: none;
            }
            #print-area {
                overflow: visible !important; 
                width: 100%;
                height: 100%;
                position: fixed !important;
                top: 0;
                right:0;
                margin: 0px auto;
            }
        }
    `;
    const intl = useIntl();
    const searchPlaceholder = intl.formatMessage({
        id: 'search'
    });
    // const handleDownloadExcel = () => {
    //     const fileExtension = '.xlsx';
    //     const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    //     FileSaver.saveAs(path, fileName + fileExtension);
    // };
    const handleDownloadExcel = () => {
        if (path) {
            window.open(excelUrl + path);
        }
    };
    const [isDisableReport, setIsDisableReport] = useState<boolean>(false);

    const handleClickReport = () => {
        setIsDisableReport(true);
        getAttendanceReport();
        dispatch(
            openSnackbar({
                open: true,
                message: 'הדוח שלך שלח בדואר לאחר 5 דקות',
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: true
            })
        );
    };

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            borderBottom="1px solid"
            borderColor={theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary[200] + 75}
            mb={2.5}
        >
            {label && (
                <Box width="40%">
                    <H3 variant="h3">
                        <FormattedMessage id={label} />
                    </H3>
                </Box>
            )}
            <Box sx={{ width: '60%', display: 'flex', justifyContent: 'end' }}>
                {setSearchText !== undefined && (
                    <OutlinedInput
                        sx={{ width: '257px', height: '40px', marginRight: '20px', marginBottom: '16px' }}
                        id="input-search-profile"
                        placeholder={searchPlaceholder}
                        startAdornment={
                            <InputAdornment position="start">
                                <IconSearch stroke={1.5} size="1rem" />
                            </InputAdornment>
                        }
                        onChange={(e) => searchResults(e)}
                        size="small"
                        disabled={disabled}
                        endAdornment={
                            (label === 'my-tests' || label === 'reception-desk') && (
                                <InputAdornment position="end">
                                    <WrapperIcon>
                                        <img src={barcode} alt="barcode" />
                                    </WrapperIcon>
                                </InputAdornment>
                            )
                        }
                    />
                )}
                <Box>
                    {label === 'group-record-management' ? (
                        <IconButton sx={{ height: '36px', width: '36px' }}>
                            <img src={excel} alt="excel" width="30px" height="30px" />
                        </IconButton>
                    ) : (
                        setAdd !== undefined && (
                            <AddIconButton onClick={() => setAdd(true)}>
                                <AddSharp
                                    htmlColor={theme.palette.common.white}
                                    sx={{ height: '20px', width: '20px' }}
                                    fontSize="inherit"
                                />
                            </AddIconButton>
                        )
                    )}
                    {setCrmDetails !== undefined && (
                        <AddIconButton onClick={() => setCrmDetails(true)}>
                            <MoreHorizIcon
                                htmlColor={theme.palette.common.white}
                                sx={{ height: '20px', width: '20px' }}
                                fontSize="inherit"
                            />
                        </AddIconButton>
                    )}

                    {label === 'class-list' && (
                        <IconButton
                            sx={{
                                height: '36px',
                                width: '36px',
                                marginRight: '5px',
                                cursor: !isDisableReport ? 'pointer' : 'not-allowed',
                                opacity: isDisableReport ? 0.5 : 1
                            }}
                            onClick={handleClickReport}
                            disabled={isDisableReport}
                        >
                            <img src={report} alt="excel" width="20px" height="20px" />
                        </IconButton>
                    )}

                    {setSync !== undefined && (
                        <AddIconButton
                            onClick={() => {
                                setSync(false);
                                setFlag(true);
                            }}
                        >
                            <SyncIcon
                                aria-disabled
                                htmlColor={syncDisable ? theme.palette.common.black : theme.palette.common.white}
                                sx={{ height: '20px', width: '20px' }}
                                fontSize="inherit"
                            />
                        </AddIconButton>
                    )}

                    {isQuestionFlag == 1 ? (
                        <>
                            {' '}
                            <IconButton sx={{ height: '36px', width: '36px' }} onClick={handleDownloadExcel}>
                                <PrintTwoTone sx={{ height: '20px', width: '20px' }} />
                            </IconButton>
                        </>
                    ) : (
                        <>
                            <ReactToPrint
                                trigger={() => (
                                    <IconButton sx={{ height: '36px', width: '36px' }} disabled={disabled}>
                                        <PrintTwoTone sx={{ height: '20px', width: '20px' }} />
                                    </IconButton>
                                )}
                                content={() => printRef.current}
                                pageStyle={pageStyle}
                            />
                        </>
                    )}
                    {setFilter !== undefined && (
                        <>
                            <IconButton
                                sx={{ height: '36px', width: '36px', marginRight: '8px' }}
                                id="demo-customized-button"
                                disabled={disabled}
                                onClick={() => setFilter(true)}
                            >
                                <FilterList sx={{ height: '20px', width: '20px' }} />
                            </IconButton>
                        </>
                    )}
                </Box>
            </Box>
            <GlobalDrawer
                width="320px"
                padding="16px"
                open={filter !== undefined && filter}
                onClose={() => setFilter && setFilter(false)}
                Component={
                    <GlobalFilter
                        availabeFilters={availableFilters}
                        filters={filters}
                        setFilters={setFilters}
                        onClose={() => setFilter && setFilter(false)}
                        showTitle={false}
                    />
                }
            />
        </Box>
    );
};

export default SubSearchSection;
